(function () {
  /* ── Size data (inches) ── */
  var BOTTOMS = [
    { size: "XS", waist: [24, 26], hip: [32, 34] },
    { size: "S", waist: [26, 28], hip: [34, 36] },
    { size: "M", waist: [28, 30], hip: [36, 38] },
    { size: "L", waist: [30, 33], hip: [38, 40] },
    { size: "XL", waist: [33, 36], hip: [40, 42] },
  ];
  var TOPS = [
    { size: "XS", overbust: [30, 32], underbust: [26, 28] },
    { size: "S", overbust: [32, 34], underbust: [28, 30] },
    { size: "M", overbust: [34, 36], underbust: [30, 32] },
    { size: "L", overbust: [36, 38], underbust: [32, 34] },
    { size: "XL", overbust: [38, 40], underbust: [34, 36] },
  ];

  function rootFromEvent(e) {
    if (e && e.target) {
      var sg = e.target.closest(".elvn-sg");
      if (sg) return sg;
    }
    return rootFromOpenModal();
  }

  function rootFromOpenModal() {
    var openModals = document.querySelectorAll(
      "modal-dialog[open], modal-dialog:not(.invisible)",
    );
    for (var i = 0; i < openModals.length; i++) {
      var sg = openModals[i].querySelector(".elvn-sg");
      if (sg) return sg;
    }
    return document.querySelector(".elvn-sg");
  }

  function isBottomsForSg(sg) {
    return sg ? sg.dataset.isBottoms === "true" : false;
  }

  function buildProductSizes(sg) {
    var raw = sg ? sg.dataset.availableSizes || "" : "";
    var bottoms = isBottomsForSg(sg);
    var base = bottoms ? BOTTOMS : TOPS;
    var key1 = bottoms ? "waist" : "overbust";
    var key2 = bottoms ? "hip" : "underbust";

    if (!raw) return base;

    var result = [];
    raw.split(",").forEach(function (psize) {
      psize = psize.trim();
      if (!psize) return;
      var parts = psize.split("/").map(function (p) {
        return p.trim().toUpperCase();
      });
      var entries = [];
      for (var pi = 0; pi < parts.length; pi++) {
        for (var bi = 0; bi < base.length; bi++) {
          if (base[bi].size === parts[pi]) {
            entries.push(base[bi]);
            break;
          }
        }
      }
      if (!entries.length) return;
      var entry = { size: psize };
      entry[key1] = [
        Math.min.apply(
          null,
          entries.map(function (e) {
            return e[key1][0];
          }),
        ),
        Math.max.apply(
          null,
          entries.map(function (e) {
            return e[key1][1];
          }),
        ),
      ];
      entry[key2] = [
        Math.min.apply(
          null,
          entries.map(function (e) {
            return e[key2][0];
          }),
        ),
        Math.max.apply(
          null,
          entries.map(function (e) {
            return e[key2][1];
          }),
        ),
      ];
      result.push(entry);
    });
    return result.length ? result : base;
  }

  var finderUnits = {};
  function getFinderUnit(sg) {
    var pid = sg ? sg.dataset.productId : "default";
    return finderUnits[pid] || "in";
  }
  function setFinderUnit(sg, unit) {
    var pid = sg ? sg.dataset.productId : "default";
    finderUnits[pid] = unit;
  }

  function activateTab(sg, target) {
    sg.querySelectorAll(".elvn-sg__tab").forEach(function (t) {
      var active = t.dataset.tab === target;
      t.classList.toggle("is-active", active);
      t.setAttribute("aria-selected", String(active));
    });
    sg.querySelectorAll(".elvn-sg__panel").forEach(function (p) {
      p.classList.toggle("is-active", p.dataset.panel === target);
    });
  }

  function updateUnitLabels(sg) {
    var unit = getFinderUnit(sg);
    var label = unit === "cm" ? "(cm)" : "(inches)";
    [
      "elvn-sg-waist-unit",
      "elvn-sg-hips-unit",
      "elvn-sg-overbust-unit",
      "elvn-sg-underbust-unit",
    ].forEach(function (id) {
      var el = sg.querySelector("#" + id);
      if (el) el.textContent = label;
    });
    var imp = sg.querySelector(".elvn-sg__height-imperial");
    var met = sg.querySelector(".elvn-sg__height-metric");
    if (imp) imp.style.display = unit === "cm" ? "none" : "";
    if (met) met.style.display = unit === "cm" ? "" : "none";
  }

  function getHeightCm(sg) {
    var unit = getFinderUnit(sg);
    if (unit === "cm") {
      var cmEl = sg.querySelector("#elvn-sg-height-cm");
      var v = cmEl && cmEl.value ? parseFloat(cmEl.value) : null;
      return v && v > 0 ? v : null;
    }
    var ftEl = sg.querySelector("#elvn-sg-height-ft");
    var inEl = sg.querySelector("#elvn-sg-height-in-part");
    var ft = ftEl && ftEl.value !== "" ? parseFloat(ftEl.value) : null;
    var inch = inEl && inEl.value !== "" ? parseFloat(inEl.value) : 0;
    if (ft === null) return null;
    return ft * 30.48 + inch * 2.54;
  }

  function showForm(sg) {
    var form = sg.querySelector(".elvn-sg__finder-form");
    var res = sg.querySelector("#elvn-sg-result");
    var err = sg.querySelector("#elvn-sg-error");
    if (form) form.style.display = "";
    if (res) res.classList.remove("is-visible");
    if (err) err.style.display = "none";
  }

  function resetState(sg) {
    if (!sg) return;
    showForm(sg);
    setFinderUnit(sg, "in");
    sg.querySelectorAll(".elvn-sg__unit-btn[data-finder-unit]").forEach(
      function (b) {
        b.classList.toggle("is-active", b.dataset.finderUnit === "in");
      },
    );
    updateUnitLabels(sg);
    sg.querySelectorAll(".elvn-sg__unit-btn[data-unit]").forEach(function (b) {
      b.classList.toggle("is-active", b.dataset.unit === "in");
    });
    sg.querySelectorAll("td[data-in]").forEach(function (td) {
      td.textContent = td.dataset.in;
    });
    [
      "elvn-sg-height-ft",
      "elvn-sg-height-in-part",
      "elvn-sg-height-cm",
    ].forEach(function (id) {
      var el = sg.querySelector("#" + id);
      if (el) el.value = "";
    });
    activateTab(sg, "finder");
  }

  function toInches(val, sg) {
    return getFinderUnit(sg) === "cm" ? val / 2.54 : val;
  }

  function recommend(m1, m2, fitPref, sg) {
    var bottoms = isBottomsForSg(sg);
    var data = buildProductSizes(sg);
    var key1 = bottoms ? "waist" : "overbust";
    var key2 = bottoms ? "hip" : "underbust";

    if (m1 < data[0][key1][0])
      return {
        size: data[0].size,
        confidence: "good",
        border: null,
        edge: "under",
      };
    if (m1 > data[data.length - 1][key1][1])
      return {
        size: data[data.length - 1].size,
        confidence: "good",
        border: null,
        edge: "over",
      };

    var matchIdx = -1;
    for (var i = 0; i < data.length; i++) {
      if (m1 >= data[i][key1][0] && m1 <= data[i][key1][1]) {
        matchIdx = i;
        break;
      }
    }

    if (matchIdx >= 0) {
      var rec = data[matchIdx].size,
        confidence = "strong",
        border = null;
      var atUpperBound = data[matchIdx][key1][1] - m1 <= 1;
      if (atUpperBound && matchIdx < data.length - 1) {
        var lo = data[matchIdx].size,
          hi = data[matchIdx + 1].size;
        confidence = "good";
        rec = fitPref === "relaxed" ? hi : lo;
        border = { lower: lo, upper: hi };
      }
      if (m2 && m2 > 0) {
        var r2 = data[matchIdx][key2];
        if (r2 && (m2 > r2[1] + 1 || m2 < r2[0] - 1)) confidence = "good";
      }
      return { size: rec, confidence: confidence, border: border };
    }

    for (var j = 0; j < data.length - 1; j++) {
      if (m1 > data[j][key1][1] && m1 < data[j + 1][key1][0]) {
        var blo = data[j].size,
          bhi = data[j + 1].size;
        return {
          size: fitPref === "relaxed" ? bhi : blo,
          confidence: "good",
          border: { lower: blo, upper: bhi },
        };
      }
    }
    return { size: data[0].size, confidence: "good", border: null };
  }

  function showResult(sg, result, m1Raw, m2Raw, fitPref, heightCm) {
    var bottoms = isBottomsForSg(sg);
    var unit = getFinderUnit(sg);
    var displaySize =
      result.size.indexOf("/") !== -1
        ? result.size.replace("/", " / ")
        : result.size;

    var resultValueEl = sg.querySelector("#elvn-sg-result-value");
    resultValueEl.textContent = displaySize;
    resultValueEl.dataset.rawSize = result.size;
    sg.querySelector("#elvn-sg-confidence-fill").style.width =
      result.confidence === "strong" ? "90%" : "60%";
    sg.querySelector("#elvn-sg-confidence-label").textContent =
      result.confidence === "strong" ? "Strong match" : "Good match";

    var unitStr = unit === "cm" ? "cm" : '"';
    var noteText =
      "Based on your " +
      (bottoms ? "waist" : "overbust") +
      " (" +
      m1Raw +
      unitStr +
      ")";
    if (m2Raw)
      noteText +=
        " and " +
        (bottoms ? "hips" : "underbust") +
        " (" +
        m2Raw +
        unitStr +
        ")";
    sg.querySelector("#elvn-sg-result-note").textContent = noteText + ".";

    var betEl = sg.querySelector("#elvn-sg-between-note");
    var betData = buildProductSizes(sg);
    var betIdx = -1;
    for (var bi = 0; bi < betData.length; bi++) {
      if (betData[bi].size === result.size) {
        betIdx = bi;
        break;
      }
    }
    var isLast = betIdx === betData.length - 1;

    if (result.edge === "under") {
      betEl.innerHTML =
        "<strong>" +
        result.size +
        "</strong> is the smallest size in this product, we recommend going with " +
        result.size +
        ".";
    } else if (result.edge === "over" || isLast) {
      betEl.innerHTML =
        "<strong>" +
        result.size +
        "</strong> is the largest size in this product, we recommend going with " +
        result.size +
        ".";
    } else if (result.border) {
      betEl.innerHTML =
        "Your measurements sit between <strong>" +
        result.border.lower +
        "</strong> and <strong>" +
        result.border.upper +
        "</strong>.<br>" +
        "For a compressive fit → stay with <strong>" +
        result.border.lower +
        "</strong><br>" +
        "For more comfort → go with <strong>" +
        result.border.upper +
        "</strong>";
    } else {
      var nxt = betData[betIdx + 1] ? betData[betIdx + 1].size : result.size;
      betEl.innerHTML =
        "For a compressive fit → stay with <strong>" +
        result.size +
        "</strong><br>" +
        "For more comfort → go with <strong>" +
        nxt +
        "</strong>";
    }
    betEl.classList.add("is-visible");

    sg.querySelector("#elvn-sg-select-btn").textContent =
      "Select " + displaySize + " & continue";
    sg.querySelector(".elvn-sg__finder-form").style.display = "none";
    sg.querySelector("#elvn-sg-result").classList.add("is-visible");

    /* GA4 */
    if (typeof gtag === "function") {
      var trackData = {
        product_id: sg.dataset.productId || "",
        product_name: sg.dataset.productName || "",
        product_type: bottoms ? "bottoms" : "tops",
        recommended_size: displaySize,
        confidence: result.confidence,
        fit_preference: fitPref,
        unit: unit,
        height_cm: heightCm ? Math.round(heightCm) : null,
      };
      if (bottoms) {
        trackData.waist = m1Raw || null;
        trackData.hips = m2Raw || null;
      } else {
        trackData.bust = m1Raw || null;
        trackData.underbust = m2Raw || null;
      }
      gtag("event", "size_recommendation", trackData);
    }
  }

  function preselectOnPage(size, sg) {
    var productId = sg ? sg.dataset.productId : null;
    if (productId) {
      var drawerItem = document.querySelector(
        '.drawer-item[data-product="' + productId + '"]',
      );
      if (drawerItem) {
        var sizeBtn = drawerItem.querySelector(".variant-btn[data-variant]");
        drawerItem.querySelectorAll(".variant-btn").forEach(function (btn) {
          if (btn.textContent.trim().toUpperCase() === size.toUpperCase()) {
            btn.click();
          }
        });
        return;
      }
    }
    var input = document.querySelector('input.opt-btn[value="' + size + '"]');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  document.addEventListener("click", function (e) {
    var sg = rootFromEvent(e);
    if (!sg) return;

    var tab = e.target.closest(".elvn-sg__tab");
    if (tab && sg.contains(tab)) {
      activateTab(sg, tab.dataset.tab);
      return;
    }

    var gotoBtn = e.target.closest("[data-goto-tab]");
    if (gotoBtn && sg.contains(gotoBtn)) {
      activateTab(sg, gotoBtn.dataset.gotoTab);
      return;
    }

    var unitBtn = e.target.closest(".elvn-sg__unit-btn[data-unit]");
    if (unitBtn && sg.contains(unitBtn)) {
      sg.querySelectorAll(".elvn-sg__unit-btn[data-unit]").forEach(
        function (b) {
          b.classList.remove("is-active");
        },
      );
      unitBtn.classList.add("is-active");
      var unit = unitBtn.dataset.unit;
      sg.querySelectorAll("td[data-in]").forEach(function (td) {
        td.textContent = unit === "cm" ? td.dataset.cm : td.dataset.in;
      });
      return;
    }

    var funitBtn = e.target.closest(".elvn-sg__unit-btn[data-finder-unit]");
    if (funitBtn && sg.contains(funitBtn)) {
      setFinderUnit(sg, funitBtn.dataset.finderUnit);
      sg.querySelectorAll(".elvn-sg__unit-btn[data-finder-unit]").forEach(
        function (b) {
          b.classList.remove("is-active");
        },
      );
      funitBtn.classList.add("is-active");
      updateUnitLabels(sg);
      return;
    }

    if (e.target.closest("#elvn-sg-find-btn") && sg.contains(e.target)) {
      var bottoms = isBottomsForSg(sg);
      var errEl = sg.querySelector("#elvn-sg-error");
      errEl.style.display = "none";
      var m1 = null,
        m2 = null;
      if (bottoms) {
        var wEl = sg.querySelector("#elvn-sg-waist"),
          hEl = sg.querySelector("#elvn-sg-hips");
        m1 = wEl && wEl.value ? parseFloat(wEl.value) : null;
        m2 = hEl && hEl.value ? parseFloat(hEl.value) : null;
      } else {
        var oEl = sg.querySelector("#elvn-sg-overbust"),
          uEl = sg.querySelector("#elvn-sg-underbust");
        m1 = oEl && oEl.value ? parseFloat(oEl.value) : null;
        m2 = uEl && uEl.value ? parseFloat(uEl.value) : null;
      }

      if (!m1 || (!bottoms && !m2)) {
        errEl.style.display = "block";
        errEl.textContent =
          !bottoms && !m2 && m1
            ? "Please enter your underbust measurement."
            : "Please enter your measurements above.";
        return;
      }

      var m1In = toInches(m1, sg);
      var m2In = m2 ? toInches(m2, sg) : null;
      var plaus = bottoms
        ? { min1: 16, max1: 60, lbl1: "waist", min2: 24, max2: 70, lbl2: "hip" }
        : {
            min1: 20,
            max1: 65,
            lbl1: "bust",
            min2: 16,
            max2: 58,
            lbl2: "underbust",
          };

      if (m1In < plaus.min1 || m1In > plaus.max1) {
        errEl.style.display = "block";
        errEl.textContent =
          "Your " +
          plaus.lbl1 +
          " measurement looks unusual. Please check and try again.";
        return;
      }
      if (m2In !== null && (m2In < plaus.min2 || m2In > plaus.max2)) {
        errEl.style.display = "block";
        errEl.textContent =
          "Your " +
          plaus.lbl2 +
          " measurement looks unusual. Please check and try again.";
        return;
      }

      var fitPref =
        (sg.querySelector('input[name="elvn-fit"]:checked') || {}).value ||
        "standard";
      var heightCm = getHeightCm(sg);
      if (!heightCm) {
        errEl.style.display = "block";
        errEl.textContent = "Please enter your height.";
        return;
      }
      if (heightCm < 100 || heightCm > 240) {
        errEl.style.display = "block";
        errEl.textContent =
          "Your height looks unusual. Please check and try again.";
        return;
      }

      showResult(
        sg,
        recommend(toInches(m1, sg), m2 ? toInches(m2, sg) : null, fitPref, sg),
        m1,
        m2,
        fitPref,
        heightCm,
      );
      return;
    }

    if (e.target.closest("#elvn-sg-select-btn") && sg.contains(e.target)) {
      var rawSize =
        sg.querySelector("#elvn-sg-result-value").dataset.rawSize ||
        sg.querySelector("#elvn-sg-result-value").textContent.trim();
      preselectOnPage(rawSize, sg);
      var modal = sg.closest("modal-dialog");
      if (modal) {
        var cb = modal.querySelector(".js-close-modal");
        if (cb) cb.click();
        else {
          modal.classList.add("invisible");
          modal.removeAttribute("open");
        }
      }
      return;
    }

    if (e.target.closest("#elvn-sg-remeasure") && sg.contains(e.target)) {
      showForm(sg);
      return;
    }
  });

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (
        m.attributeName === "open" &&
        m.target.tagName.toLowerCase() === "modal-dialog" &&
        m.target.hasAttribute("open")
      ) {
        var sg = m.target.querySelector(".elvn-sg");
        if (sg) {
          resetState(sg);
          break;
        }
      }
    }
  }).observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ["open"],
  });
})();
